(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5744"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5744"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2rxJM", function(module, exports) {

$parcel$export(module.exports, "setLinesWrapper", () => $1c7845f0e1de0887$export$8f060496e19d4bbb);
function $1c7845f0e1de0887$export$8f060496e19d4bbb(lines, callback) {
    // Wrap each line in a .line-wrapper span
    lines.forEach((line)=>{
        const wrapper = document.createElement("span");
        wrapper.classList.add("line-wrapper");
        line.parentNode.insertBefore(wrapper, line);
        wrapper.appendChild(line);
    });
    if (typeof callback === "function") callback();
}

});

parcelRegister("cljH0", function(module, exports) {

$parcel$export(module.exports, "createSVGGrid", () => $8fc6b8bbd146cdca$export$d47c320381fa2abf);
function $8fc6b8bbd146cdca$export$d47c320381fa2abf(container, squaresPerRow, fill, onlyEmbed) {
    if (!container) {
        console.error("Container not found");
        return;
    }
    // Get the container's dimensions
    const containerWidth = container.clientWidth;
    const containerHeight = container.clientHeight;
    const responsiveSquares = window.innerWidth <= 991 ? squaresPerRow / 2 : squaresPerRow;
    // Calculate the size of each square
    const squareSize = parseInt(containerWidth / responsiveSquares);
    // Calculate the number of squares per column
    const squaresPerColumn = Math.ceil(containerHeight / squareSize);
    // Create a unique ID for the mask
    const maskId = "mask-" + Math.random().toString(36).substr(2, 9);
    if (!onlyEmbed) {
        // Create SVG content
        let svgContent = `
                <svg viewBox="0 0 ${containerWidth} ${containerHeight}" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style="position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;">
                    <defs>
                        <mask id="${maskId}">
                            ${Array.from({
            length: squaresPerColumn
        }).map((_, row)=>Array.from({
                length: responsiveSquares
            }).map((_, col)=>{
                const x = col * squareSize;
                const y = row * squareSize;
                return `<rect x="${x}" y="${y}" width="${squareSize + 1}" height="${squareSize + 1}" fill="${fill ? fill : "#000000"}"/>`;
            }).join("")).join("")}
                        </mask>
                    </defs>
                </svg>`;
        // Create wrapper for the SVG and mask
        const maskContainer = document.createElement("div");
        maskContainer.className = "mask-container";
        maskContainer.style.maskImage = `url(#${maskId})`;
        // Append SVG to maskContainer
        maskContainer.innerHTML = svgContent;
        container.parentNode.insertBefore(maskContainer, container);
        maskContainer.appendChild(container);
        return maskContainer.querySelector("svg");
    } else {
        // Create SVG content
        let svgContent = `
                <svg viewBox="0 0 ${containerWidth} ${containerHeight}" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style="position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;">
                            ${Array.from({
            length: squaresPerColumn
        }).map((_, row)=>Array.from({
                length: squaresPerRow
            }).map((_, col)=>{
                const x = col * squareSize;
                const y = row * squareSize;
                return `<rect x="${x}" y="${y}" width="${squareSize + 1}" height="${squareSize + 1}" fill="${fill ? fill : "#000000"}"/>`;
            }).join("")).join("")}
                </svg>`;
        container.insertAdjacentHTML("beforeend", svgContent);
        return svgContent;
    }
}

});


var $2rxJM = parcelRequire("2rxJM");

var $cljH0 = parcelRequire("cljH0");
// Link timelines to scroll position
function $c2ee0746a8bca6f4$var$createHomeIntroText(triggerElement, words, index, amount) {
    const isFirst = index === 0;
    const isLast = index === amount - 1;
    if (isFirst) gsap.fromTo(triggerElement.querySelector(".section-sticky"), {
        opacity: 1
    }, {
        opacity: 0,
        scrollTrigger: {
            trigger: triggerElement,
            scrub: true,
            start: "90% bottom",
            end: "bottom bottom",
            // markers: true,
            pin: false
        }
    });
    if (!isLast && !isFirst) {
        gsap.fromTo(words, {
            yPercent: 100
        }, {
            yPercent: 0,
            stagger: 0.1,
            scrollTrigger: {
                trigger: triggerElement,
                scrub: true,
                start: "top top",
                end: "20% top",
                // markers: true,
                pin: false
            }
        });
        gsap.fromTo(words, {
            yPercent: 0
        }, {
            yPercent: -100,
            stagger: 0.1,
            immediateRender: false,
            scrollTrigger: {
                trigger: triggerElement,
                scrub: true,
                start: "90% bottom",
                end: "bottom bottom",
                // markers: true,
                pin: false
            }
        });
    }
    if (isLast) {
        const lines = triggerElement.querySelectorAll(".intro-text");
        const tl = gsap.timeline({
            paused: true
        });
        lines.forEach((line, i)=>{
            if (i === lines.length - 1) {
                gsap.set(line.querySelectorAll(".line"), {
                    yPercent: 0
                });
                tl.fromTo(line, {
                    height: 0
                }, {
                    height: "auto",
                    duration: 1,
                    delay: 2,
                    ease: "none"
                });
            } else tl.fromTo(line.querySelectorAll(".line"), {
                yPercent: 100
            }, {
                yPercent: 0,
                duration: 1,
                ease: "none"
            });
        });
        tl.fromTo(triggerElement.querySelector(".button"), {
            yPercent: 105
        }, {
            yPercent: 0,
            duration: 1
        });
        gsap.fromTo(tl, {
            progress: 0
        }, {
            progress: 1,
            scrollTrigger: {
                trigger: triggerElement,
                scrub: true,
                start: "top top",
                end: "30% top",
                // markers: true,
                pin: false
            }
        });
        // logic for fade out on scrub video
        const canvasSquares = document.querySelectorAll(".section.home-hero .mask-container svg rect");
        gsap.set(canvasSquares, {
            opacity: 1
        });
        gsap.fromTo(canvasSquares, {
            opacity: 1
        }, {
            opacity: 0,
            stagger: {
                each: 0.005,
                from: "random"
            },
            scrollTrigger: {
                trigger: triggerElement,
                scrub: true,
                start: "bottom bottom",
                end: "bottom center",
                // markers: true,
                pin: false
            }
        });
    }
}
function $c2ee0746a8bca6f4$export$a447da1e9ff61e55() {
    // Split all words on the brand core section
    const homeIntroText = new SplitType(".intro-text", {
        types: "lines",
        tagName: "span"
    });
    (0, $2rxJM.setLinesWrapper)(homeIntroText.lines, ()=>{
        gsap.set(".intro-text .line", {
            yPercent: 100
        });
    });
    const sections = document.querySelectorAll(".intro-sequence .sticky-wrapper");
    // set logic for fade out on scrub video
    (0, $cljH0.createSVGGrid)(document.querySelector(".section.home-hero canvas"), 20);
    document.querySelector(".section.home-hero .bg-canvas-el").classList.add("init");
    sections.forEach((section, i)=>{
        const words = section.querySelectorAll(".line");
        $c2ee0746a8bca6f4$var$createHomeIntroText(section, words, i, sections.length);
    });
}



var $cljH0 = parcelRequire("cljH0");

var $2rxJM = parcelRequire("2rxJM");
function $590857349261d23b$export$d4d6102d3f698f0() {
    const wrapper = document.querySelector(".section.list-scroll"), sections = wrapper.querySelectorAll(".section-list-scroll_inner");
    if (!sections) return;
    sections.forEach((section, i)=>{
        const id = section.dataset.section, trigger = document.getElementById(id), title = section.querySelector("h2"), description = section.querySelector("p"), button = section.querySelector(".button"), videoBg = wrapper.querySelector(`.section-scroll-video-bg[data-section-id="${id}"] video`), anchorLink = wrapper.querySelector(`.section-nav-item[data-target="${id}"]`);
        let descriptionLines;
        const maskEl = (0, $cljH0.createSVGGrid)(title, 10);
        const maskVideo = (0, $cljH0.createSVGGrid)(videoBg, 10);
        // Split all words on the brand core section
        const descriptionEls = new SplitType(description, {
            types: "lines",
            tagName: "span"
        });
        (0, $2rxJM.setLinesWrapper)(descriptionEls.lines, ()=>{
            descriptionLines = description.querySelectorAll(".line");
        });
        let scrollTimeout;
        $590857349261d23b$var$setListSectionScroll(trigger, i === 0, i === sections.length - 1, maskEl, maskVideo, descriptionLines, button, anchorLink, scrollTimeout);
    });
}
function $590857349261d23b$var$setListSectionScroll(trigger, isFirst, isLast, titleMaskEl, maskVideo, descriptionLines, button, anchorLink, scrollTimeout) {
    const squaresTitle = titleMaskEl.querySelectorAll("rect");
    const squaresVideo = maskVideo.querySelectorAll("rect");
    if (!isFirst) {
        gsap.set(squaresTitle, {
            opacity: 0
        });
        gsap.set(squaresVideo, {
            opacity: 0
        });
        gsap.set(descriptionLines, {
            yPercent: 105
        });
        gsap.set(button, {
            yPercent: 105
        });
    } else {
        anchorLink.classList.add("active");
        gsap.set(squaresTitle, {
            opacity: 1
        });
        gsap.set(squaresVideo, {
            opacity: 1
        });
    }
    const tlContent = gsap.timeline({
        paused: true
    });
    const tlVideo = gsap.timeline({
        paused: true
    });
    tlContent.to(squaresTitle, {
        opacity: 1,
        duration: 0.01,
        overwrite: "auto",
        stagger: {
            from: "random",
            each: 0.01
        },
        ease: "power4.inOut"
    }, 0).to(descriptionLines, {
        yPercent: 0,
        stagger: 0.02,
        duration: 0.5,
        overwrite: "auto",
        ease: "power4.inOut"
    }, 0).to(button, {
        yPercent: 0,
        duration: 0.5,
        overwrite: "auto",
        ease: "power4.inOut"
    }, 0).to(squaresTitle, {
        opacity: 0,
        duration: 0.01,
        overwrite: "auto",
        stagger: {
            from: "random",
            each: 0.01
        },
        ease: "power4.inOut"
    }, 0.5).to(descriptionLines, {
        yPercent: -105,
        stagger: 0.02,
        duration: 0.5,
        overwrite: "auto",
        ease: "power4.inOut"
    }, 0.5).to(button, {
        yPercent: -105,
        duration: 0.5,
        overwrite: "auto",
        ease: "power4.inOut"
    }, 0.5);
    tlContent.addPause(0.5);
    tlContent.addLabel("out", 0.5);
    tlVideo.to(squaresVideo, {
        opacity: 1,
        duration: 0.005,
        overwrite: "auto",
        stagger: {
            from: "random",
            each: 0.005
        },
        ease: "power4.out"
    }).addPause().addLabel("out").to(squaresVideo, {
        opacity: 0,
        duration: 0.005,
        overwrite: "auto",
        stagger: {
            from: "random",
            each: 0.005
        },
        ease: "power4.out"
    });
    gsap.timeline({
        scrollTrigger: {
            trigger: trigger,
            start: "top center",
            end: "bottom center",
            scrub: true,
            fastScrollEnd: 500,
            preventOverlaps: "home-services",
            pin: false,
            // markers: true,
            onEnter: ()=>{
                if (!isFirst) {
                    tlContent.play();
                    tlVideo.play();
                    anchorLink.classList.add("active");
                }
            },
            onEnterBack: ()=>{
                if (!isLast) {
                    tlContent.progress(1).reverse();
                    tlVideo.progress(1).reverse();
                    anchorLink.classList.add("active");
                }
            },
            onLeave: ()=>{
                if (!isLast) {
                    tlContent.seek("out").play();
                    tlVideo.seek("out").play();
                    anchorLink.classList.remove("active");
                }
            },
            onLeaveBack: ()=>{
                if (!isFirst) {
                    tlContent.seek("out").reverse();
                    tlVideo.seek("out").reverse();
                    anchorLink.classList.remove("active");
                }
            }
        }
    });
}


function $ca14fce580ff58e8$export$7245151ef7522291() {
    if (!document.querySelector(".news-slider")) return;
    const sliders = document.querySelectorAll(".news-slider_wrapper");
    sliders.forEach((s)=>{
        const slider = new Swiper(s.querySelector(".news-slider"), {
            slidesPerView: "auto",
            navigation: {
                nextEl: s.querySelector(".slider-controls .button.next"),
                prevEl: s.querySelector(".slider-controls .button.prev")
            }
        });
        // gsap logic
        const slides = s.querySelectorAll(".news-item");
        gsap.set(slides, {
            y: "3rem",
            opacity: 0
        });
        gsap.timeline({
            scrollTrigger: {
                trigger: s,
                start: "25% bottom",
                onEnter: ()=>{
                    gsap.to(slides, {
                        y: "0rem",
                        opacity: 1,
                        stagger: 0.1,
                        duration: 0.5,
                        ease: "expo.out"
                    });
                }
            }
        });
    // slides.forEach((slide) => {
    //   const c01 = slide.querySelector('.news-item-thumb-img._02');
    //   const c02 = slide.querySelector('.news-item-thumb-img._03');
    //   const tl = gsap.timeline({ paused: true });
    //   tl.to(c01, {
    //     scale: .8,
    //     duration: .3,
    //     ease: "expo.inOut"
    //   }).to(c02, {
    //     scale: .6,
    //     duration: .3,
    //     ease: "expo.inOut"
    //   }, "-=0.3");
    //   slide.addEventListener('mouseover', () => { tl.play(); })
    //   slide.addEventListener('mouseout', () => { tl.reverse(); })
    // });
    });
}


document.fonts.ready.then(()=>{
    (0, $c2ee0746a8bca6f4$export$a447da1e9ff61e55)();
    (0, $590857349261d23b$export$d4d6102d3f698f0)();
});
(0, $ca14fce580ff58e8$export$7245151ef7522291)();

})();
//# sourceMappingURL=home.js.map
